import { supplierPaymentsService } from "@/services/suplpayments-api.service";

const ADD_FILE_UPLOADS = 'addFileUploads';
const ADD_RECENT_FILE_UPLOAD = 'addRecentFileUpload'
const ADD_WORKITEM_FILE_SCHEMAS = 'addWorkItemFileSchemas'

const state = () => ({
    recentFiles: [],
    workItemFileSchemas: []
});

const actions = {
    uploadWorkItemFiles({ commit }, formData) {
        return new Promise((resolve, reject) => {
            supplierPaymentsService
                .uploadWorkItemFiles(formData)
                .then(response => {
                    let { data: apiResponse } = response
                    commit(ADD_RECENT_FILE_UPLOAD, apiResponse.uploads)
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    getWorkItemFiles({ commit }, formData) {
        return new Promise((resolve, reject) => {
            supplierPaymentsService
                .uploadWorkItemFileList()
                .then(response => {
                    let { data: apiResponse } = response
                    commit(ADD_FILE_UPLOADS, apiResponse.uploads)
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    },
    getWorkItemFileSchemas({ commit }) {
        return new Promise((resolve, reject) => {
            supplierPaymentsService
                .getWorkItemFileSchemas()
                .then(response => {
                    let { data: apiResponse } = response
                    commit(ADD_WORKITEM_FILE_SCHEMAS, apiResponse.schemas)
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
                .finally()
        });
    }
};
const getters = {
    getRecentFiles: state => state.recentFiles,
    getWorkItemFileSchemas: state => state.workItemFileSchemas
};
const mutations = {
    [ADD_FILE_UPLOADS](state, payload) {
        state.recentFiles = [...(payload || [])]
    },
    [ADD_RECENT_FILE_UPLOAD](state, payload) {
        state.recentFiles = [...(payload || []) , ...(state.recentFiles || [])]
    },
    [ADD_WORKITEM_FILE_SCHEMAS](state, payload) {
        state.workItemFileSchemas = [...(payload || [])]
    }
}
export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}